export const calculateTableDimensions = (table, circleRadius, edgePadding) => {
  let leftCount = 0,
    rightCount = 0,
    topCount = 0,
    bottomCount = 0;
  table.items.forEach((item) => {
    switch (item.side) {
      case "left":
        leftCount++;
        break;
      case "right":
        rightCount++;
        break;
      case "top":
        topCount++;
        break;
      case "bottom":
        bottomCount++;
        break;
    }
  });

  const maxVerticalCount =
    leftCount > 0 || rightCount > 0 ? Math.max(leftCount, rightCount) : 1;
  const maxHorizontalCount = Math.max(topCount, bottomCount);

  const adjustedWidth =
    (circleRadius * 2 + edgePadding * 2) * maxHorizontalCount;
  const adjustedHeight =
    (circleRadius * 2 + edgePadding * 2) * maxVerticalCount;

  return {
    adjustedWidth,
    adjustedHeight,
    leftCount,
    rightCount,
    topCount,
    bottomCount,
  };
};
export const drawTable = (
  context,
  obj,
  canvasOffset,
  zoom,
  circleRadius,
  circlePadding,
  edgePadding,
  selectedTableCircles,
  HoldTypes,
  seatingTickets
) => {
  const {
    adjustedWidth,
    adjustedHeight,
    leftCount,
    rightCount,
    topCount,
    bottomCount,
  } = calculateTableDimensions(obj, circleRadius, edgePadding);
  const centerX = circleRadius + edgePadding + adjustedWidth / 2;
  const centerY = circleRadius + edgePadding + adjustedHeight / 2;
  const findTicket = (tierID) => {
    return seatingTickets.find((tier) => tier.tierID === tierID);
  };

  context.save();
  context.fillStyle = obj.items[0].tierColor;
  context.scale(zoom, zoom); // Apply zoom
  context.translate(
    canvasOffset.x + obj.x + centerX,
    canvasOffset.y + obj.y + centerY
  );
  context.rotate((obj.rotation * Math.PI) / 180);
  context.translate(-centerX, -centerY);
  // context.translate(
  //   -(canvasOffset.x + obj.x + centerX),
  //   -(canvasOffset.y + obj.y + centerY)
  // );
  // Draw the base rectangle for the table
  context.fillRect(
    leftCount > 0 ? circleRadius + edgePadding : 0,
    topCount > 0 ? circleRadius + edgePadding : 0,
    adjustedWidth,
    adjustedHeight
  );
  context.save(); // Save the current context state, including the non-rotated state
  context.translate(
    leftCount > 0
      ? adjustedWidth / 2 + circleRadius + edgePadding
      : adjustedWidth / 2,
    adjustedHeight / 2 + circleRadius + edgePadding
  ); // Move to the text position
  context.rotate((-obj.rotation * Math.PI) / 180); // Rotate the context for text drawing; convert degrees to radians

  context.fillStyle = "white"; // Text color
  context.font = "12px Arial"; // Adjust font size and family as needed
  context.textAlign = "center"; // Center the text horizontally
  context.textBaseline = "middle"; // Center the text vertically
  context.fillText(obj.name, 0, 0);
  context.restore();
  // Function to draw circles with appropriate padding
  const drawCircle = (cx, cy, item) => {
    context.beginPath();
    context.arc(cx, cy, circleRadius, 0, Math.PI * 2);
    context.fillStyle = obj.color;
    const assigned = findTicket(item.tierID);
    if (item.tierColor) {
      context.fillStyle = item.tierColor; // Border color for selected circles
    }
    // if (item.holdColor) {
    //   context.fillStyle = item.holdColor; // Border color for selected circles
    // }
    // if (item.holdID) {
    const HoldAccess = HoldTypes.filter((hold) => hold.HoldID === item.holdID);
    //   if (HoldAccess[0].accessCode === null) {
    //     context.fillStyle = "black";
    //   } // Border color for selected circles
    // }
    if (
      item.isTaken ||
      (item.holdID && HoldAccess[0].accessCode === null) ||
      !assigned
    ) {
      context.fillStyle = "black"; // Border color for selected circles
    }
    context.fill();
    context.save(); // Save the current context state, including the non-rotated state
    context.translate(cx, cy); // Move to the text position
    context.rotate((-obj.rotation * Math.PI) / 180); // Rotate the context for text drawing; convert degrees to radians
    if (
      selectedTableCircles.some((selection) => {
        return selection.objectId === obj.id && selection.itemID === item.id;
      })
    )
      context.fillStyle = "black";
    else context.fillStyle = "white"; // Text color
    context.font = "12px Arial"; // Adjust font size and family as needed
    context.textAlign = "center"; // Center the text horizontally
    context.textBaseline = "middle"; // Center the text vertically
    // if (item.isTaken || (item.holdID && HoldAccess[0].accessCode === null))
    //   context.fillText("X", 0, 0);
    // else {
    if (
      selectedTableCircles.some((selection) => {
        return selection.objectId === obj.id && selection.itemID === item.id;
      })
    )
      context.fillText("\u2713", 0, 0);

    // if (
    //   item.holdID &&
    //   HoldAccess[0].accessCode &&
    //   !selectedTableCircles.some((selection) => {
    //     return selection.objectId === obj.id && selection.itemID === item.id;
    //   })
    // )
    //   context.fillText("\u{1F512}", 0, 0);
    if (
      !selectedTableCircles.some((selection) => {
        return selection.objectId === obj.id && selection.itemID === item.id;
      })
    )
      context.fillText(item.name, 0, 0);

    context.restore();
    // //console.log(selectedTableCircles);

    if (
      selectedTableCircles.some((selection) => {
        return selection.objectId === obj.id && selection.itemID === item.id;
      })
    ) {
      context.strokeStyle = "black"; // Border color for selected circles
      context.lineWidth = 2; // Border width
      context.stroke();
    }
  };
  // Draw circles on the left side
  for (let i = 0; i < leftCount; i++) {
    drawCircle(
      0,
      (i + 1) * (2 * circleRadius + circlePadding) -
        circleRadius +
        edgePadding +
        (topCount > 0 ? circleRadius : 0),
      obj.items[i]
    );
  }

  // Draw circles on the right side
  for (let i = 0; i < rightCount; i++) {
    drawCircle(
      adjustedWidth + circleRadius * 2 + edgePadding * 2,
      (i + 1) * (2 * circleRadius + circlePadding) -
        circleRadius +
        edgePadding +
        (topCount > 0 ? circleRadius : 0),
      obj.items[i + leftCount]
    );
  }

  // Draw circles on the top side
  for (let i = 0; i < topCount; i++) {
    drawCircle(
      (i + 1) * (2 * circleRadius + circlePadding) -
        circleRadius +
        edgePadding +
        (leftCount > 0 ? circleRadius : -circlePadding),
      0,
      obj.items[i + leftCount + rightCount]
    );
  }

  // Draw circles on the bottom side
  for (let i = 0; i < bottomCount; i++) {
    drawCircle(
      (i + 1) * (2 * circleRadius + circlePadding) -
        circleRadius +
        edgePadding +
        (leftCount > 0 ? circleRadius : -circlePadding),
      adjustedHeight + circleRadius * 2 + edgePadding * 2,
      obj.items[i + leftCount + rightCount + topCount]
    );
  }

  context.restore();
};
